/**
 * Coverage page state — prior-acts selection, retro date, waiver reason,
 * plus rating-calculate status flags. In-memory only.
 */
class CoverageStore {
  #listeners = new Set();

  #priorActs = "no";
  #retroDate = "";
  #waiverReason = "uninsured";

  get priorActs() { return this.#priorActs; }
  set priorActs(v) { this.#priorActs = v; this.#notify(); }

  get retroDate() { return this.#retroDate; }
  set retroDate(v) { this.#retroDate = v; this.#notify(); }

  get waiverReason() { return this.#waiverReason; }
  set waiverReason(v) { this.#waiverReason = v; this.#notify(); }

  // Rating preview (POST /rating/calculate)
  #calculateRatingResult = null;
  #calculateRatingLoading = false;
  #calculateRatingError = null;

  get calculateRatingResult() { return this.#calculateRatingResult; }
  set calculateRatingResult(v) { this.#calculateRatingResult = v; this.#notify(); }

  get calculateRatingLoading() { return this.#calculateRatingLoading; }
  set calculateRatingLoading(v) { this.#calculateRatingLoading = !!v; this.#notify(); }

  get calculateRatingError() { return this.#calculateRatingError; }
  set calculateRatingError(v) { this.#calculateRatingError = v; this.#notify(); }

  // Commit-rating status (PUT /rating from license-scope continue)
  #updateRatingLoading = false;
  #updateRatingError = null;

  get updateRatingLoading() { return this.#updateRatingLoading; }
  set updateRatingLoading(v) { this.#updateRatingLoading = !!v; this.#notify(); }

  get updateRatingError() { return this.#updateRatingError; }
  set updateRatingError(v) { this.#updateRatingError = v; this.#notify(); }

  subscribe(listener) {
    this.#listeners.add(listener);
    return () => this.#listeners.delete(listener);
  }

  #notify() { this.#listeners.forEach((l) => l()); }

  clear() {
    this.#priorActs = "no";
    this.#retroDate = "";
    this.#waiverReason = "uninsured";
    this.#calculateRatingResult = null;
    this.#calculateRatingLoading = false;
    this.#calculateRatingError = null;
    this.#updateRatingLoading = false;
    this.#updateRatingError = null;
    this.#notify();
  }
}

const coverageStore = new CoverageStore();
export default coverageStore;
